const { adminCall } = require("./_utils");

module.exports = {
  draft: data => adminCall("api.draft", data),
  create: data => adminCall("api.create", data),
  modify: data => adminCall("api.modify", data),
  remove: uid => adminCall("api.remove", {uid}),
}
